import { watchEffect } from 'vue'
import { useAuthStore } from '@/stores/auth'
import type { Directive, DirectiveBinding } from 'vue'

// WeakMap keeps cleanup functions without leaking element references.
const stopHandlers = new WeakMap<Element, () => void>()

function applyPermission(el: HTMLElement, value: string): void {
  const authStore = useAuthStore()
  const stop = watchEffect(() => {
    el.style.display = authStore.hasPermission(value) ? '' : 'none'
  })
  stopHandlers.set(el, stop)
}

export const permission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    if (!binding.value || typeof binding.value !== 'string') {
      throw new Error(`need permissions! Like v-permission="'profiles.edit_profile'"`)
    }
    applyPermission(el, binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    if (binding.value !== binding.oldValue) {
      stopHandlers.get(el)?.()
      if (!binding.value || typeof binding.value !== 'string') {
        throw new Error(`need permissions! Like v-permission="'profiles.edit_profile'"`)
      }
      applyPermission(el, binding.value)
    }
  },
  unmounted(el) {
    stopHandlers.get(el)?.()
    stopHandlers.delete(el)
  },
}
